export const BRAND = '#a461d8'
export const BRAND_LIGHT = '#a461d836'
export const BRAND_DIVIDER = '#a461d852'
export const BRAND_BG = '#fcf0ff'

export const STATUS_CONFIG = {
  // Backend status codes (from task_status.code)
  pending: { color: 'orange', label: 'Ne pritje' },
  processing: { color: 'magenta', label: 'Ne progres' },
  completed: { color: 'green', label: 'Perfunduar' },
  completed_partially: { color: 'cyan', label: 'Pjeserisht' },
  refused: { color: 'red', label: 'Refuzuar' },
  // API status field values (from assigned tasks list)
  ongoing: { color: 'magenta', label: 'Ne progres' },
  unfinished: { color: 'orange', label: 'E paperfunduar' },
  '': { color: 'default', label: 'Ne pritje' },
}

// Map task_status.name (Albanian) to status key
const STATUS_NAME_MAP = {
  'ne pritje': 'pending',
  'ne progres': 'processing',
  'perfunduar': 'completed',
  'perfunduar pjeserisht': 'completed_partially',
  'refuzuar': 'refused',
  'e paperfunduar': 'unfinished',
}

export const getStatusConfig = (status) => {
  if (!status) return STATUS_CONFIG['']
  // Try direct match first
  if (STATUS_CONFIG[status]) return STATUS_CONFIG[status]
  // Try matching by Albanian name (case insensitive)
  const mapped = STATUS_NAME_MAP[status.toLowerCase()]
  if (mapped && STATUS_CONFIG[mapped]) return STATUS_CONFIG[mapped]
  return STATUS_CONFIG.pending
}

export const getStatusKey = (taskData) => {
  // From task_status object (detail API)
  if (taskData.task_status?.name) {
    const name = taskData.task_status.name.toLowerCase()
    return STATUS_NAME_MAP[name] || taskData.task_status.code || ''
  }
  // From status field (list API)
  return taskData.status || ''
}

export const PRIORITY_COLORS = {
  high: 'red',
  medium: 'orange',
  low: 'green',
}
